/**
 * An action type attributed to a notification -
 */
export enum ActionType {
  REMINDER_DASHBOARD = 'REMINDER_DASHBOARD',
  INTERACTION_DASHBOARD = 'INTERACTION_DASHBOARD',
}
